import {ENDPOINT, METHOD} from '@/constants';
import {DTO} from '@/shared';
import {IBodyCreateUser, IBodyUpdateUser, IQueryGetUser} from '@/types';
import {ListFilterOptions} from './base.dto';

export class GetUserListDTO extends DTO {
  public param: undefined;
  public url = ENDPOINT.USER;
  public method = METHOD.GET;
  public body: unknown;
  public readonly responseClass: unknown;
  public query: IQueryGetUser;
  constructor(query: IQueryGetUser) {
    super();
    this.query = query;
  }
}
export interface UserFilterOption extends ListFilterOptions {
  search?: string;
  name?: string;
  isActive?: boolean;
  sort?: string;
  onboardDate?: string;
}

export class CreateUserDTO extends DTO {
  public url = ENDPOINT.USER;
  public method = METHOD.POST;
  public query: undefined;
  public param: undefined;

  constructor(public body: IBodyCreateUser) {
    super();
  }
}
export class UpdateUserDTO extends DTO {
  public body: IBodyUpdateUser;
  public url: string = ENDPOINT.USER_UPDATE;
  public method = METHOD.PUT;
  public param: {id: number | undefined};
  public query: undefined;
  constructor(param: {id: number | undefined}, body: IBodyUpdateUser) {
    super();
    this.param = param;
    this.body = body;
  }
}

export class DeleteUserDTO extends DTO {
  public param: {id: number} | undefined;
  public url = ENDPOINT.USER_UPDATE;
  public method = METHOD.DELETE;
  public body: undefined;
  public readonly responseClass: unknown;
  public query: undefined;
  constructor(param: {id: number}) {
    super();
    this.param = param;
  }
}

export class GetUserByIdDTO extends DTO {
  public param: {id: number} | undefined;
  public url = ENDPOINT.USER_UPDATE;
  public method = METHOD.GET;
  public body: undefined;
  public readonly responseClass: unknown;
  public query: undefined;
  constructor(param: {id: number}) {
    super();
    this.param = param;
  }
}

export class GetInfoAccountDTO extends DTO {
  public query: unknown;
  public param: undefined;
  public url = ENDPOINT.USER_ME;
  public method = METHOD.GET;
  public body: unknown;
  public readonly responseClass: unknown;
  constructor() {
    super();
  }
}

export class GetUserShareDTO extends DTO {
  public query: unknown;
  public param: undefined;
  public url = ENDPOINT.USER_SHARE;
  public method = METHOD.GET;
  public body: unknown;
  public readonly responseClass: unknown;
  constructor(query: {templateId: number}) {
    super();
    this.query = query;
  }
}
